import React from 'react';
import { CompanyCallRingSettingsPanel } from '@/components/calls/CompanyCallRingSettingsPanel';

const CompanyCallRingSettings = () => {
  return (
    <div className="container mx-auto py-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Atendimento do Número da Empresa</h1>
        <p className="text-muted-foreground mt-2">
          Configure os grupos de toque (Ring All) do canal do número da empresa
        </p>
      </div>
      <CompanyCallRingSettingsPanel />
    </div>
  );
};

export default CompanyCallRingSettings;
